import { render } from "./MarkenBoxenStartseite.vue?vue&type=template&id=0df537f1"
import script from "./MarkenBoxenStartseite.vue?vue&type=script&lang=ts"
export * from "./MarkenBoxenStartseite.vue?vue&type=script&lang=ts"

import "./MarkenBoxenStartseite.vue?vue&type=style&index=0&id=0df537f1&lang=scss"
script.render = render

export default script